import React from "react";
import CMSComponent from "../CMSComponent";
const arrowIcon = require("../../assets/ic_arrow_see_more.svg");

const MoreButton = ({ label, path, ariaHidden, newTab = false, locale }) => {
  const hrefPath = path.startsWith("http") ? path : `/${locale}${path}`;
  return (
    <a
      style={{
        color: "#6621c0",
        fontSize: "14px",
        fontWeight: "700",
        transition: "0.2s",
        backgroundImage: `url(${arrowIcon})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right 4px",
        paddingRight: "30px"
      }}
      href={hrefPath}
      aria-hidden={ariaHidden}
      aria-label={label}
      target={newTab ? "_blank" : ""}
    >
      {label}
    </a>
  );
};

export default CMSComponent(null, MoreButton, 19);
